<template>
  <v-container grid-list-md fluid>
    <v-layout row wrap>
      <v-flex md12>
        <data-table ref="tableBase" @detail="detail" />
      </v-flex>
      <v-flex v-show="tipo && tipo != 'Exclusiones'" id="tableDetalle" md12>
        <data-table-detalle ref="tableDetalle" />
      </v-flex>
      <v-flex v-show="tipo && tipo == 'Exclusiones'" id="tableExclusiones" md12>
        <data-table-exclusiones ref="tableExclusiones" />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import DataTable from "@/views/bases/base/DataTable"; /** *******************************/
import DataTableDetalle from "@/views/bases/base/DataTableDetalle"; /** *******************************/
import DataTableExclusiones from "@/views/bases/base/DataTableExclusiones"; /** *******************************/
import { scrollToElement } from "@/helpers/form-scroll-to";

export default {
  name: "BaseModule"
  , components: { DataTable, DataTableDetalle, DataTableExclusiones }
  , data() {
    return { tipo: undefined, view: { title: this.$t("view.bases.base.title") } };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , methods: {
    reload() {
      this.$refs.tableBase.refreshData();
    }
    , async detail(tipo, clave) {
      this.tipo = tipo;

      if (tipo != "Exclusiones") {
        this.$refs.tableDetalle.open(clave);
        setTimeout(() => scrollToElement(this, "#tableDetalle"), 100);
      }

      if (tipo == "Exclusiones") {
        this.$refs.tableExclusiones.open(clave);
        setTimeout(scrollToElement(this, "#tableDetalle"), 100);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/bases/base/Base.vue